module.exports = "./img/0df138538de0b61b86de206115b1a65d.jpg";